import { useState } from 'react';
import axios from 'axios';
import toastr from 'toastr';
import { Save, X, AlertTriangle } from 'lucide-react';

const ROLES = [
    { role: 'Primary', title: 'Primary Advisor' },
    { role: 'Additional Primary', title: 'Additional Primary Advisors' },
    { role: 'Associate', title: 'Associate Advisors' },
];

const JgAdvisorCodeEditor = ({ item, onSaved, onCancel }) => {
    const advisors = item.advisors || [];
    const [codes, setCodes] = useState(() => {
        const seed = {};
        advisors.forEach((a) => { seed[a.email] = a.chamberCode || ''; });
        return seed;
    });
    const [saving, setSaving] = useState(false);

    const setCode = (email, val) => setCodes((prev) => ({ ...prev, [email]: val }));
    // Associates always have their own record; primary & additional-primary need the primary's distro.
    const savable = (a) => (a.role === 'Associate' ? true : !!item.distroId);

    const save = async () => {
        const payload = advisors
            .filter((a) => savable(a) && (codes[a.email] || '').trim())
            .map((a) => ({ email: a.email, role: a.role, chamberCode: (codes[a.email] || '').trim() }));
        if (payload.length === 0) { toastr.warning('Enter at least one chamber code'); return; }
        setSaving(true);
        try {
            await axios.post(`/api/Advisors/jg-pending/${item.id}/save`, { advisors: payload });
            toastr.success('Chamber codes saved');
            onSaved(item.id);
        } catch (error: any) {
            toastr.error(error?.response?.data?.message || 'Failed to save chamber codes');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="jg-editor">
            {ROLES.map(({ role, title }) => {
                const people = advisors.filter((a) => a.role === role);
                if (!people.length) return null;
                return (
                    <div className="jg-adv-group" key={role}>
                        <div className="jg-adv-group-title">{title}</div>
                        {people.map((a, i) => (
                            <div className="jg-editor-row" key={i}>
                                <div className="jg-editor-adv">
                                    {a.name ? <span className="jg-name">{a.name}</span> : null}
                                    <span className="jg-email-plain">{a.email}</span>
                                </div>
                                {savable(a) ? (
                                    <input
                                        className="jg-code-input"
                                        type="text"
                                        placeholder="Chamber Code"
                                        value={codes[a.email] ?? ''}
                                        onChange={(e) => setCode(a.email, e.target.value)}
                                    />
                                ) : (
                                    <span className="jg-editor-note warn"><AlertTriangle size={12} /> no distro account</span>
                                )}
                            </div>
                        ))}
                    </div>
                );
            })}
            <div className="jg-editor-actions">
                <button className="jg-btn-secondary" onClick={onCancel} disabled={saving}>
                    <X size={14} /> Cancel
                </button>
                <button className="jg-save" onClick={save} disabled={saving}>
                    <Save size={14} /> {saving ? 'Saving…' : 'Save'}
                </button>
            </div>
        </div>
    );
};

export default JgAdvisorCodeEditor;
